import { provideRouter, Routes } from '@angular/router';
import { NextPageRoute } from '@cvx/nextpage';
import { SectionDetailsComponent } from './components/sharedComponents/section-details/section-details.component';
import { AirComponent } from './components/AIRModule/air/air.component';
import { AirComplianceDetailsComponent } from './components/AIRModule/air-compliance-details/air-compliance-details.component';
import { OaCompilanceDetailsComponent } from './components/OAModule/oa-compilance-details/oa-compilance-details.component';
import { OaHomeComponent } from './components/OAModule/oa-home/oa-home.component';
import { ApprovalTabComponent } from './components/HomeModule/approval-tab/approval-tab.component';
import { HomeLocationsComponent } from './components/HomeModule/home-locations/home-locations.component';
import { ReportsHomeComponent } from './components/ReportsModule/reports-home/reports-home.component';
import { OperationInstallationRemovalDetailComponent } from './components/OperationModule/operation-installation-removal-detail/operation-installation-removal-detail.component';
import { OperatorInstallationRemovalComponent } from './components/OperationModule/operator-installation-removal/operator-installation-removal.component';
import { OperationCreateNewTlrRepumpComponent } from './components/OperationModule/operation-create-new-tlr-repump/operation-create-new-tlr-repump.component';
import { AdminTlrAdministartorIpegComponent } from './components/AdminModule/Reports/admin-tlr-administartor-ipeg/admin-tlr-administartor-ipeg.component';
import { TlreditorchangerepairedComponent } from './components/AdminModule/Other Functions/tlreditorchangerepaired/tlreditorchangerepaired.component';
import { TlrHealthComponent } from './components/AdminModule/Other Functions/tlr-health/tlr-health.component';
import { AdminDashboardComponent } from './components/AdminModule/admin-dashboard/admin-dashboard.component';
import { DailyUpdateRunCommandComponent } from './components/AdminModule/Daily Update/daily-update-run-command/daily-update-run-command.component';
import { TlrDataEditorPermanentRepairDateComponent } from './components/AdminModule/Other Functions/tlr-data-editor-permanent-repair-date/tlr-data-editor-permanent-repair-date.component';
import { TlrBreakdownReportComponent } from './components/ReportsModule/tlr-status-reports/tlr-breakdown-report/tlr-breakdown-report.component';
import { TlrBeyondDateReportComponent } from './components/ReportsModule/tlr-status-reports/tlr-beyond-date-report/tlr-beyond-date-report.component';
import { LeadEngineerHomeComponent } from './components/LeadEngineerModule/lead-engineer-home/lead-engineer-home.component';
import { ManageDivisionsComponent } from './components/AdminModule/User Interface configuration/manage-divisions/manage-divisions.component';
import { ManageMaterialServiceComponent } from './components/AdminModule/User Interface configuration/manage-material-service/manage-material-service.component';
import { ManageServicesComponent } from './components/AdminModule/User Interface configuration/manage-services/manage-services.component';
import { ManageRepairTypesComponent } from './components/AdminModule/User Interface configuration/manage-repair-types/manage-repair-types.component';
import { ManageLeaksComponent } from './components/AdminModule/User Interface configuration/manage-leaks/manage-leaks.component';
import { ManagePlantsComponent } from './components/AdminModule/User Interface configuration/manage-plants/manage-plants.component';
import { ManageSectionsComponent } from './components/AdminModule/User Interface configuration/manage-sections/manage-sections.component';
import { OmcMaintainanceComponent } from './components/AdminModule/Notification Configuration/omc-maintainance/omc-maintainance.component';
import { OaMaintainanceComponent } from './components/AdminModule/Notification Configuration/oa-maintainance/oa-maintainance.component';
import { OrphanReportComponent } from './components/ReportsModule/tlr-status-reports/orphan-report/orphan-report.component';
import { UserRoleManagementComponent } from './components/AdminModule/Notification Configuration/user-role-management/user-role-management.component';
import { EmailDistributionComponent } from './components/AdminModule/Notification Configuration/email-distribution/email-distribution.component';
import { SystemMessageBoardComponent } from './components/AdminModule/Notification Configuration/system-message-board/system-message-board.component';
import { AdminReportsAnamolyComponent } from './components/AdminModule/Reports/admin-reports-anamoly/admin-reports-anamoly.component';
import { DisplayHierarchyComponent } from './components/AdminModule/TLR-Maximo_OERI-Hirerachy/display-hierarchy/display-hierarchy.component';
import { InspectorMaintainanceComponent } from './components/AdminModule/Notification Configuration/inspector-maintainance/inspector-maintainance.component';
import { HirerchyCheckerRunCommandComponent } from './components/AdminModule/TLR-Maximo_OERI-Hirerachy/hirerchy-checker-run-command/hirerchy-checker-run-command.component';
import { AssignEngineerComponent } from './components/engineer/assign-engineer/assign-engineer.component';
import { LeadEngineerCompilanceDetailsComponent } from './components/LeadEngineerModule/lead-engineer-compilance-details/lead-engineer-compilance-details.component';
import { OperationOverviewComponent } from './components/OperationModule/operation-overview/operation-overview.component';
import { FindTlrBlueTagNumberComponent } from './components/ReportsModule/air-compliance-reports/find-tlr-blue-tag-number/find-tlr-blue-tag-number.component';
import { LdarFugitiveEmissionReportComponent } from './components/ReportsModule/air-compliance-reports/ldar-fugitive-emission-report/ldar-fugitive-emission-report.component';
import { AssignedToCaiComponent } from './components/ReportsModule/inspector-oa-engineer-reports/assigned-to-cai/assigned-to-cai.component';
import { EngineeredInstalledReportComponent } from './components/ReportsModule/inspector-oa-engineer-reports/engineered-installed-report/engineered-installed-report.component';
import { FindTlrGivenWorkorderComponent } from './components/ReportsModule/inspector-oa-engineer-reports/find-tlr-given-workorder/find-tlr-given-workorder.component';
import { InspectedInstalledReportComponent } from './components/ReportsModule/inspector-oa-engineer-reports/inspected-installed-report/inspected-installed-report.component';
import { InspectionsLookAheadReportComponent } from './components/ReportsModule/inspector-oa-engineer-reports/inspections-look-ahead-report/inspections-look-ahead-report.component';
import { InspectorCaiReportComponent } from './components/ReportsModule/inspector-oa-engineer-reports/inspector-cai-report/inspector-cai-report.component';
import { InspectorInstalledTlrReportComponent } from './components/ReportsModule/inspector-oa-engineer-reports/inspector-installed-tlr-report/inspector-installed-tlr-report.component';
import { InspectorValidationRequiredComponent } from './components/ReportsModule/inspector-oa-engineer-reports/inspector-validation-required/inspector-validation-required.component';
import { MissingPermanentRepairDateReportComponent } from './components/ReportsModule/inspector-oa-engineer-reports/missing-permanent-repair-date-report/missing-permanent-repair-date-report.component';
import { PermanentRepairWithin90DaysComponent } from './components/ReportsModule/inspector-oa-engineer-reports/permanent-repair-within-90-days/permanent-repair-within-90-days.component';
import { MatchOeriOpenTlrComponent } from './components/ReportsModule/oeri-reports/match-oeri-open-tlr/match-oeri-open-tlr.component';
import { OverdueTlrReportsComponent } from './components/ReportsModule/oeri-reports/overdue-tlr-reports/overdue-tlr-reports.component';
import { DiscoveredPastReportsComponent } from './components/ReportsModule/oeri-reports/discovered-past-reports/discovered-past-reports.component';
import { OrphanedTlrreportsComponent } from './components/ReportsModule/oeri-reports/orphaned-tlrreports/orphaned-tlrreports.component';
import { InvalidDivisonPlantReportComponent } from './components/ReportsModule/maximo-reports/invalid-divison-plant-report/invalid-divison-plant-report.component';
import { MaximoDataIntegrityCheckComponent } from './components/ReportsModule/maximo-reports/maximo-data-integrity-check/maximo-data-integrity-check.component';
import { CaliforniaRegulationReportComponent } from './components/AdminModule/Reports/california-regulation-report/california-regulation-report.component';
import { RoleGuard } from './gaurds/roleGaurd';
import { PrdInfoReportComponent } from './components/resources/prd-info-report/prd-info-report.component';
import { InspectorDetailsComponent } from './components/inspector/inspector-details/inspector-details.component';

export const routes: Routes = [
    {
        path: "",
        component: HomeLocationsComponent,
        title: "home",
    },
    {
        path: "",
        loadComponent: () => import('./components/menuModule/menu-layout/menu-layout.component'). // Update this path to the correct location if necessary
            then(m => m.MenuLayoutComponent),
        children: [
            {
                path: "details",
                loadComponent: () => import('./components/HomeModule/tag-number-details/tag-number-details.component'). // Ensure this path is correct or update it to the actual file location
                    then(m => m.TagNumberDetailsComponent)
            },
            {
                path: "app-location-detail/:sectionName/:reportType",
                loadComponent: () => import('./components/HomeModule/location-detail/location-detail.component'). // Ensure this path is correct or update it to the actual file location
                    then(m => m.LocationDetailComponent)
            },
            // {
            //     path: "details",
            //     component: TagNumberDetailsComponent,
            //     // runGuardsAndResolvers :'always'   
            // },
            {
                path: "details-section/:tagNumber",
                component: SectionDetailsComponent,
                // runGuardsAndResolvers :'always'   
            },
            {
                path: "app-air",
                component: AirComponent,
                canActivate: [RoleGuard],
                data: { roles: ['AI'] }
            },
            {
                path: "air-compliance-details-section/:tagNumber",
                component: AirComplianceDetailsComponent,
                canActivate: [RoleGuard],
                data: { roles: ['AI'] }
            }, {
                path: "operator-Installation-Removal",
                component: OperatorInstallationRemovalComponent
            },
            {
                path: 'app-oa',
                component: OaHomeComponent
            },
            {
                path: "oa-compliance-details-section/:tagNumber",
                component: OaCompilanceDetailsComponent
            },
            {
                path: 'leadEngineer',
                component: LeadEngineerHomeComponent,
                canActivate: [RoleGuard],
                data: { roles: ['LE'] }
            },
            {
                path: "leadEngineer-compliance-details-section/:tagNumber",
                component: LeadEngineerCompilanceDetailsComponent,
                canActivate: [RoleGuard],
                data: { roles: ['LE'] }
            },
            {
                path: "reports-home",
                component: ReportsHomeComponent
            },
            {
                path: "tlr-status-reports",
                loadComponent: ()=>import('./components/ReportsModule/tlr-status-reports/tlr-status-reports.component'). // Ensure this path is correct or update it to the actual file location
                then(m=>m.TlrStatusReportsComponent),
                children:[{
                    path:"status-report/:type",
                    loadComponent: ()=>import('./components/ReportsModule/tlr-status-reports/shared-tlr-status-reports/status-report/status-report.component'). // Ensure this path is correct or update it to the actual file location
                    then(m=>m.StatusReportComponent),
                  },
                  {
                    path:"orphan-report/:type",
                    loadComponent: ()=>import('./components/ReportsModule/tlr-status-reports/orphan-report/orphan-report.component'). // Ensure this path is correct or update it to the actual file location
                    then(m=>m.OrphanReportComponent),
                  },
                  {
                    path:"removed-report",
                    loadComponent: ()=>import('./components/ReportsModule/tlr-status-reports/removed-report/removed-report.component'). // Ensure this path is correct or update it to the actual file location
                    then(m=>m.RemovedReportComponent),
                  },
                  {
                    path: "shutDown-report",
                    loadComponent: () => import('./components/ReportsModule/tlr-status-reports/shutdown-report/shutdown-report.component'). // Ensure this path is correct or update it to the actual file location
                    then(m => m.ShutdownReportComponent),
                  }
                ]      
            },

            {
                path: "tlr-breakdown-report",
                component: TlrBreakdownReportComponent

            },
            {
                path: "tlr-beyond-date-report",
                component: TlrBeyondDateReportComponent

            },
            {
                path:"app-find-tlr-blue-tag-number/blue-tag",
                component: FindTlrBlueTagNumberComponent

            },
            {
                path: "ldar-fugitive-report/report",
                component: LdarFugitiveEmissionReportComponent
            },
            {
                path: "missing-permanent-repair-report/date-report",
                component: MissingPermanentRepairDateReportComponent
            },
            {
                path: "inspection-look-ahead/report-component",
                component: InspectionsLookAheadReportComponent
            },
            {
                path: "inspection-cai-report/report-component",
                component: InspectorCaiReportComponent
            },
            {
                path: "assigned-to-cai-component/cai-component",
                component: AssignedToCaiComponent
            },
            {
                path: "inspection-installed/report-component",
                component: InspectedInstalledReportComponent
            },
            {
                path: "match-oeri-open-tlr",
                component: MatchOeriOpenTlrComponent
            },
            {
                path: "over-due-tlr-details-report",
                component: OverdueTlrReportsComponent
            },
            {
                path: "discovered-past-reports",
                component: DiscoveredPastReportsComponent
            },
            {
                path: "orphaned-tlr-report",
                component: OrphanedTlrreportsComponent
            },
            {
                path: "engineered-installed/report-component",
                component: EngineeredInstalledReportComponent
            },
            {
                path: "permannent-repair/report-component",
                component: PermanentRepairWithin90DaysComponent
            },
            {
                path: "inspector-validation/required-component",
                component: InspectorValidationRequiredComponent
            },
            {
                path: "inspector-installedtlr/report-component",
                component: InspectorInstalledTlrReportComponent
            },
            {
                path: "find-tlr/work-order-component",
                component: FindTlrGivenWorkorderComponent
            },
            {
                path: "invalid-division/plant-report",
                component: InvalidDivisonPlantReportComponent
            },
            {
                path: "maximo-data/intergrity",
                component: MaximoDataIntegrityCheckComponent
            },            {
                path: "manage-divisions",
                component: ManageDivisionsComponent

            },
            {
                path: "manage-sections",
                component: ManageSectionsComponent

            },
            {
                path: "manage-plants",
                component: ManagePlantsComponent

            },
            {
                path: "manage-leaks",
                component: ManageLeaksComponent

            },
            {
                path: "manage-repairTypes",
                component: ManageRepairTypesComponent

            },
            {
                path: "manage-services",
                component: ManageServicesComponent

            },
            {
                path: "manage-materialState",
                component: ManageMaterialServiceComponent

            },
            {
                path: "omc-maintainance",
                component: OmcMaintainanceComponent

            },
            {
                path: "oa-maintainance",
                component: OaMaintainanceComponent

            },
            {
                path: "inspector-maintainance",
                component: InspectorMaintainanceComponent

            },
            {
                path: "orphan-report",
                component: OrphanReportComponent

            },
            {
                path: "approval-details/:tagNumber",
                component: ApprovalTabComponent
            },
            {
                path: "resources/user-guide/:mode",
                loadComponent: () => import('./components/resources/user-guide/user-guide.component')
                    .then(m => m.UserGuideComponent)
            },
            {
                path: "resources/turnaround",
                loadComponent: () => import('./components/resources/turnaround/turnaround.component')
                    .then(m => m.TurnaroundComponent)
            },
            {
                path: "resources/maximo-status",
                loadComponent: () => import('./components/resources/maximo/maximo.component')
                    .then(m => m.MaximoComponent)
            },
            {
                path: "resources/prds",
                loadComponent: () => import('./components/resources/prd/prd.component')
                    .then(m => m.PrdComponent)
            },
             {
                path: "prd-info-report",
                loadComponent: () => import('./components/resources/prd-info-report/prd-info-report.component')
                    .then(m => m.PrdInfoReportComponent)
            },
            {
                path: "resources/repumps",
                loadComponent: () => import('./components/resources/repump/repump.component')
                    .then(m => m.RepumpComponent)
            },
            {
                path: "resources/sectiondetails",
                loadComponent: () => import('./components/resources/section-details/section-details.component')
                    .then(m => m.SectionDetailsComponent)
            },
            {
                path: "resources/turnaround-details/:outage/:unit",
                loadComponent: () => import('./components/resources/turnaround/turnaround-details/turnaround-details.component')
                    .then(m => m.TurnaroundDetailsComponent)
            },
            {
                path: "resources/turnaround-details/:section",
                loadComponent: () => import('./components/resources/turnaround/turnaround-details/turnaround-details.component')
                    .then(m => m.TurnaroundDetailsComponent)
            },
            {
                path: "inspector",
                loadComponent: () => import('./components/inspector/inspector.component')
                    .then(m => m.InspectorComponent),
                canActivate: [RoleGuard],
                data: { roles: ['IN'] }
            },
            {
                path: "inspector-details/:tagNumber/:action",
                loadComponent: () => import('./components/inspector/inspector-details/inspector-details.component')
                    .then(m => m.InspectorDetailsComponent),
                canActivate: [RoleGuard],
                data: { roles: ['IN'] }
            },
            {
                path: "engineer",
                loadComponent: () => import('./components/engineer/engineer.component')
                    .then(m => m.EngineerComponent),
                canActivate: [RoleGuard],
                data: { roles: ['EN'] }
            },

            {
                path: "assign-engineer/:tlrId/:action",
                loadComponent: () => import('./components/engineer/assign-engineer/assign-engineer.component')
                    .then(m => m.AssignEngineerComponent),
                canActivate: [RoleGuard],
                data: { roles: ['EN'] }
            },
            {
                path: "app-operation-installation-removal-detail",
                component: OperationInstallationRemovalDetailComponent

            },
            {
                path: "operation-create-new-tlr-repump/:a",
                component: OperationCreateNewTlrRepumpComponent
            },
            {
                path: "operation-create-new-tlr-repump/:a/:tagNumber",
                component: OperationCreateNewTlrRepumpComponent
            },
            {
                path: "app-admin-tlr-administartor-ipeg",
                component: AdminTlrAdministartorIpegComponent,
                canActivate: [RoleGuard],
                data: { roles: ['AD'] }
            },
            {
                path: "app-admin-reports-anamoly",
                component: AdminReportsAnamolyComponent,
                canActivate: [RoleGuard],
                data: { roles: ['AD'] }
            },
            {
                path: "app-california-regulation-report",
                component: CaliforniaRegulationReportComponent
            },
            {
                path: "app-tlr-editor-change-repaired",
                component: TlreditorchangerepairedComponent
            },
            {
                path: "app-tlr-health",
                component: TlrHealthComponent
            },
            {
                path: "app-admin-dashboard",
                component: AdminDashboardComponent,
                canActivate: [RoleGuard],
                data: { roles: ['AD'] }
            },
            {
                path: "app-daily-update-run-command",
                component: DailyUpdateRunCommandComponent
            },
            {
                path: "app-tlr-data-editor",
                component: TlrDataEditorPermanentRepairDateComponent,
                data: { mode: 'permanent-data-editor' }
            },
            {
                path: "app-tlr-data-editor-permanent-repair-date",
                component: TlrDataEditorPermanentRepairDateComponent,
                data: { mode: 'permanent-repair' }
            },
            {
                path: "app-display-hierarchy",
                component: DisplayHierarchyComponent
            },
            {
                path: "app-hirerchy-checker-run-command",
                component: HirerchyCheckerRunCommandComponent
            },
            {
                path: "management-report",
                loadComponent: () => import('./components/ReportsModule/management-report/management-report.component').then(m => m.ManagementReportComponent),
                children: [
                    {
                        path: "tlr-management-report",
                        loadComponent: () => import('./components/ReportsModule/management-report/tlr-management-report/tlr-management-report.component').then(m => m.TLRManagementReportComponent)
                    },
                    {
                        path: "tlr-management-report-details",
                        loadComponent: () => import('./components/ReportsModule/management-report/tlr-management-report-details/tlr-management-report-details.component').then(m => m.TLRManagementReportDetailsComponent)
                    },
                    {
                        path: "tlr-aging-report",
                        loadComponent: () => import('./components/ReportsModule/management-report/tlr-aging-report/tlr-aging-report.component').then(m => m.TLRAgingReportComponent)
                    },
                    {
                        path: "tlr-aging-report-details",
                        loadComponent: () => import('./components/ReportsModule/management-report/tlr-aging-report-details/tlr-aging-report-details.component').then(m => m.TlrAgingReportDetailsComponent)
                    },
                    {
                        path: "tlr-greater-than-five-year-report",
                        loadComponent: () => import('./components/ReportsModule/management-report/tlr-greater-than-five-year-report/tlr-greater-than-five-year-report.component').then(m => m.TLRGreaterThanFiveYearReportComponent)
                    },
                    {
                        path: "tlr-greater-than-five-year-report-details",
                        loadComponent: () => import('./components/ReportsModule/management-report/tlr-greater-than-five-year-report-details/tlr-greater-than-five-year-report-details.component').then(m => m.TlrGreaterThanFiveYearReportDetailsComponent)
                    },
                    {
                        path: "tlr-stewardship-report",
                        loadComponent: () => import('./components/ReportsModule/management-report/tlr-stewardship-report/tlr-stewardship-report.component').then(m => m.TLRStewardshipReportComponent)
                    },
                    {
                        path: "tlr-stewardship-report-details",
                        loadComponent: () => import('./components/ReportsModule/management-report/tlr-stewardship-report-details/tlr-stewardship-report-details.component').then(m => m.TlrStewardshipReportDetailsComponent)
                    },
                    {
                        path: "tlr-historical-data-report",
                        loadComponent: () => import('./components/ReportsModule/management-report/tlr-historical-data-report/tlr-historical-data-report.component').then(m => m.TLRHistoricalDataReportComponent)
                    }
                ],
            },
            {
                path: "integrity-threat-reports",
                loadComponent: () => import('./components/ReportsModule/integrity-threat-reports/integrity-threat-reports.component').then(m => m.IntegrityThreatReportsComponent),
                children: [
                    {
                        path: 'entire-refinery-itr-tlr-report',
                        loadComponent: () => import('./components/ReportsModule/integrity-threat-reports/entire-refinery-itr-tlr-report/entire-refinery-itr-tlr-report.component').then(m => m.EntireRefineryITRTLRReportComponent)
                    },
                    {
                        path: 'entire-refinery-itr-tlr-report-details',
                        loadComponent: () => import('./components/ReportsModule/integrity-threat-reports/entire-refinery-itr-tlr-report-details/entire-refinery-itr-tlr-report-details.component').then(m => m.EntireRefineryItrTlrReportDetailsComponent)
                    },
                    {
                        path: 'oppis-line-detail-report',
                        loadComponent: () => import('./components/ReportsModule/integrity-threat-reports/oppis-line-detail-report/oppis-line-detail-report.component').then(m => m.OPPISLineDetailReportComponent)
                    },
                    {
                        path: 'refinery-itr-oppis-report',
                        loadComponent: () => import('./components/ReportsModule/integrity-threat-reports/refinery-itr-oppis-report/refinery-itr-oppis-report.component').then(m => m.RefineryITROPPISReportComponent)
                    },
                ]
            },
            {
                path: "compliance-reports",
                loadComponent: () => import('./components/ReportsModule/compliance-reports/compliance-reports.component').then(m => m.ComplianceReportsComponent),
                children: [

                    {
                        path: "psm-group",
                        loadComponent: () => import('./components/ReportsModule/compliance-reports/complaince-report-psm-group/complaince-report-psm-group.component').then(m => m.ComplainceReportPsmGroupComponent)

                    },
                    {
                        path: "cal-arp-report",
                        loadComponent: () => import('./components/ReportsModule/compliance-reports/cal-arp-report/cal-arp-report.component').then(m => m.CalARPReportComponent)
                    },
                    {
                        path: "compliance-v-and-v-report",
                        loadComponent: () => import('./components/ReportsModule/compliance-reports/compliance-v-and-v-report/compliance-v-and-v-report.component').then(m => m.ComplianceVAndVReportComponent)
                    },
                    {
                        path: "fei-lookahead-report",
                        loadComponent: () => import('./components/ReportsModule/compliance-reports/fei-lookahead-report/fei-lookahead-report.component').then(m => m.FEILookaheadReportComponent)
                    },
                    {
                        path: "tlr-surveillance-report",
                        loadComponent: () => import('./components/ReportsModule/compliance-reports/tlr-surveillance-report/tlr-surveillance-report.component').then(m => m.TLRSurveillanceReportComponent)
                    }
                ]
            },
            {
                path: "urb-reports",
                loadComponent: () => import('./components/ReportsModule/urb-reports/urb-reports.component').then(m => m.URBReportsComponent),
                children: [
                    {
                        path: "urb-report-search",
                        loadComponent: () => import('./components/ReportsModule/urb-reports/urb-tlr-look-ahead-report/urb-tlr-look-ahead-report.component').then(m => m.URBTLRLookAheadReportComponent)
                    }
                ]
            },
            {
                path: "app-user-role-management",
                component: UserRoleManagementComponent
            },
            {
                path: "app-email-distribution",
                component: EmailDistributionComponent
            },
            {
                path: "app-system-message-board",
                component: SystemMessageBoardComponent
            },
            {
                path: "admin/notification-configuration/email-events",
                loadComponent: () => import('./components/AdminModule/Notification Configuration/email-events/email-events.component')
                    .then(m => m.EmailEventsComponent),
                canActivate: [RoleGuard],
                data: { roles: ['AD'] }
            },
            {
                path: "app-operation-overview",
                component: OperationOverviewComponent
            },
            {
                path: 'admin',
                children: [
                    {
                        path: 'other-functions',
                        children: [
                            {
                                path: 'data-editor/air',
                                component: AirComplianceDetailsComponent,
                                canActivate: [RoleGuard],
                                data: { roles: ['AI'] }
                            },
                             {
                                path: 'data-editor/inspector',
                                component: InspectorDetailsComponent,
                                // canActivate: [RoleGuard],
                                // data: { roles: ['AI'] }
                            },
                            {
                                path: 'data-editor/operations',
                                loadComponent: () => import('./components/AdminModule/Other Functions/other-function-data-editor-operations/other-function-data-editor-operations.component')
                                    .then(c => c.OtherFunctionDataEditorOperationsComponent),
                                canActivate: [RoleGuard],
                                data: { roles: ['AD'] }
                            },
                            {
                                path: 'data-editor/oa-details',
                                component: OaCompilanceDetailsComponent,
                                canActivate: [RoleGuard],
                                data: { roles: ['AD'] }
                            },
                            {
                                path: 'data-editor/engineering-details',
                                component: AssignEngineerComponent,
                                canActivate: [RoleGuard],
                                data: { roles: ['AD'] }
                            },
                        ]
                    },
                ]
            }

        ]

    }

]

export const appConfig = {
    providers: [provideRouter(routes)]
}


export const nextPageRoutes: NextPageRoute[] = [
    {
        path: 'home',
        title: 'Home',
        megaMenu: {
            customClasses: '',
            customContent: '',
            columnSize: 4
        },
        children: [
            {
                path: 'model-document',
                title: 'model-documents',
                children: [
                    {
                        path: 'new',
                        title: 'new',
                        children: [
                            {
                                path: 'Sub new',
                                title: ' Sub new',
                            }
                        ]
                    },
                    {
                        path: 'test',
                        title: 'test'
                    }
                ]
            }
        ]
    },
    {
        path: 'plan',
        title: 'plan'
    },
    {
        path: 'documents',
        title: 'documents',
        megaMenu: {
            customClasses: '',
            customContent: '',
            columnSize: 7
        },
        children: [
            {
                path: 'model-document',
                title: 'model-documents',
                children: [
                    {
                        path: 'new',
                        title: 'new',

                    },
                    {
                        path: 'test',
                        title: 'test',
                    }
                ]
            }
        ]
    },
    {
        path: '**',
        redirectTo: ''
    }
];
